export default "__VITE_ASSET__GRGKw0AY__"